module.exports = __webpack_public_path__ + "img/logo-elken.fa30e058.png";